"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";

export default function RootNotFound() {
  const router = useRouter();

  useEffect(() => {
    const pathname = typeof window !== "undefined" ? window.location.pathname : "";
    const match = pathname.match(/^\/(en|vi|cn)(\/|$)/);
    const cookieLocale =
      typeof document !== "undefined"
        ? document.cookie
            .split("; ")
            .find((row) => row.startsWith("NEXT_LOCALE="))
            ?.split("=")[1]
        : undefined;
    const locale = match ? match[1] : (cookieLocale || "vi");
    router.replace(`/${locale}`);
  }, [router]);

  return null;
}
